import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useApp } from '../contexts/AppContext';
import { Sidebar, NavigationButton } from './styled/Layout';
import { Flex } from './styled/Layout';

const Navigation = () => {
  const location = useLocation();
  const { user } = useAuth();
  const { activeApp, deploymentInfo } = useApp();

  if (!user) return null;

  // Hide entire sidebar for singleapp-public (shop uses its own navigation)
  const isSingleAppPublic = deploymentInfo?.type === 'singleapp-public';
  if (isSingleAppPublic) return null;

  const isActive = (path) => {
    return location.pathname === path;
  };

  const getAppRoutes = () => {
    if (!activeApp) return [];

    // Apps that don't have a Settings page
    const appsWithoutSettings = ['marketing', 'shop', 'certus', 'project750k'];

    const routes = [
      { path: `/${activeApp}`, label: 'Dashboard', icon: '📊' }
    ];

    // Only add Settings if the app has one
    if (!appsWithoutSettings.includes(activeApp)) {
      routes.push({ path: `/${activeApp}/settings`, label: 'Settings', icon: '⚙️' });
    }

    // Only add Analytics if the app has one (marketing has its own analytics route)
    // Heston has project-specific analytics, so no top-level analytics link
    if (activeApp !== 'heston') {
      routes.push({ path: `/${activeApp}/analytics`, label: 'Analytics', icon: '📈' });
    }

    return routes;
  };

  const getAdminRoutes = () => {
    if (!user || user.role !== 'admin') return [];

    // Hide App Management for single-app deployments (both private and public)
    const isSingleApp = deploymentInfo?.type === 'singleapp-private' || deploymentInfo?.type === 'singleapp-public';
    if (isSingleApp) return [];

    return [
      { path: '/admin/apps', label: 'App Management', icon: '🚀' }
    ];
  };

  return (
    <Sidebar>
      <Flex direction="column" gap="var(--space-3)">
        <div>
          <Flex direction="column" gap="var(--space-1)">
            {getAppRoutes().map((route) => (
              <NavigationButton
                key={route.path}
                as={Link}
                to={route.path}
                className={isActive(route.path) ? 'selected' : ''}
              >
                <span>{route.icon}</span>
                <span>{route.label}</span>
              </NavigationButton>
            ))}
          </Flex>
        </div>

        {getAdminRoutes().length > 0 && (
          <div>
            <h4 style={{
              fontSize: 'var(--font-size-label)',
              fontWeight: 'var(--font-weight-semibold)',
              color: 'var(--text-primary)',
              margin: '0 0 var(--space-2) 0',
              padding: '0 var(--space-2)'
            }}>
              Administration
            </h4>
            <Flex direction="column" gap="var(--space-1)">
              {getAdminRoutes().map((route) => (
                <NavigationButton
                  key={route.path}
                  as={Link}
                  to={route.path}
                  className={isActive(route.path) ? 'selected' : ''}
                >
                  <span>{route.icon}</span>
                  <span>{route.label}</span>
                </NavigationButton>
              ))}
            </Flex>
          </div>
        )}
      </Flex>
    </Sidebar>
  );
};

export default Navigation;
